import React from "react";
import { Link } from "react-router-dom";
import { useI18n, formatPrice } from "../i18n";
import { ArrowUpRight, Users, Cog, Fuel } from "lucide-react";

const CarCard = ({ car }) => {
  const { t, lang } = useI18n();
  return (
    <Link
      to={`/fleet/${car.id}`}
      className="group block bg-[#0f0f0f] border border-white/10 rounded-sm overflow-hidden lift"
      data-testid={`car-card-${car.id}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[#0a0a0a]">
        <img
          src={car.image}
          alt={car.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
        />
        <div className="absolute top-4 left-4 text-label">{car.category}</div>
        <div className="absolute top-4 right-4 bg-[#FFB400] text-white text-xs font-mono-ui px-3 py-1.5 tracking-widest uppercase">
          {car.year}
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-label mb-1">{car.brand}</p>
            <h3 className="font-heading text-2xl text-white tracking-tight">
              {car.name}
            </h3>
          </div>
          <ArrowUpRight
            size={22}
            className="text-zinc-500 group-hover:text-[#FFB400] transition-colors"
          />
        </div>

        <div className="grid grid-cols-3 gap-3 mt-5 text-xs text-zinc-400">
          <div className="flex items-center gap-1.5">
            <Cog size={14} />
            <span className="truncate">{car.transmission}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Users size={14} />
            <span>{car.seats}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Fuel size={14} />
            <span className="truncate">{car.fuel}</span>
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-white/5 flex items-baseline justify-between">
          <div>
            <p className="text-label">{t.common.from}</p>
            <p className="font-heading text-3xl font-semibold text-white">
              {formatPrice(car.price_per_day)}
              <span className="text-xs text-zinc-500 font-mono-ui ml-1 tracking-widest">
                {t.common.perDay}
              </span>
            </p>
          </div>
          <span className="text-[#FFB400] text-xs font-mono-ui uppercase tracking-widest group-hover:translate-x-1 transition-transform">
            {t.common.viewDetails} →
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CarCard;
